import React, { useState } from 'react';
import './Services.css';

const Services = () => {
  const [activeService, setActiveService] = useState('Student Counselling');

  const services = [
    'Student Counselling',
    'University Selection',
    'University Admission',
    'Financial Assistance',
    'Visa Application',
    'Pre-Departure Guidance',
    'Accommodation Support'
  ];

  return (
    <section className="services section">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        
        <div className="services-tabs">
          {services.map((service) => (
            <button
              key={service}
              className={`service-tab ${activeService === service ? 'active' : ''}`}
              onClick={() => setActiveService(service)}
            >
              {service}
            </button>
          ))}
        </div>

        <div className="service-content">
          <div className="service-description">
            <h3>{activeService}</h3>
            <p>
              {activeService === 'Student Counselling' && 'Choosing to study abroad is a life-changing decision, and having the right guidance makes all the difference. Our expert counsellors provide one-on-one sessions to understand your academic background, career goals, and personal preferences. We help you identify the best study options that match your aspirations and guide you every step of the way.'}
              {activeService === 'University Selection' && 'With thousands of universities worldwide, finding the right one can be overwhelming. We simplify the process by shortlisting institutions based on your academic strengths, field of interest, budget, and preferred location. Our team ensures you choose a university that not only offers quality education but also provides opportunities for future career growth.'}
              {activeService === 'University Admission' && 'We assist you throughout the application process, from preparing outstanding statements of purpose and recommendation letters to ensuring all documents are accurately submitted. Our goal is to increase your chances of securing admission to your dream university without unnecessary stress or delays.'}
              {activeService === 'Financial Assistance' && 'Studying abroad is an investment in your future, and we help you make it affordable. Our advisors provide detailed information about scholarships, grants, and funding opportunities offered by universities and governments. We also guide you in planning your finances to manage tuition fees, living costs, and other expenses.'}
              {activeService === 'Visa Application' && 'A successful visa application requires careful preparation. Our visa specialists provide end-to-end support, including document preparation, interview coaching, and compliance with the latest immigration requirements. We make sure your application is complete, accurate, and submitted on time.'}
              {activeService === 'Pre-Departure Guidance' && 'Moving to a new country comes with both excitement and challenges. Our pre-departure sessions cover everything you need to know—from cultural adaptation and travel tips to healthcare, banking, and safety measures. This ensures you arrive confident and prepared for your new journey.'}
              {activeService === 'Accommodation Support' && 'Finding safe and comfortable housing is crucial for a smooth study experience. We assist you in securing suitable accommodation, whether it’s university dormitories, shared housing, or private apartments. Our trusted network ensures you find a home that fits your lifestyle and budget.'}
            </p>
          </div>
          
          {/* <div className="service-features">
            <div className="feature">
              <i className="fas fa-check-circle"></i>
              <span>Expert Guidance</span>
            </div>
            <div className="feature">
              <i className="fas fa-check-circle"></i>
              <span>24/7 Support</span>
            </div>
            <div className="feature">
              <i className="fas fa-check-circle"></i>
              <span>Success Rate</span>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Services;
